window.PATH_PARAM_SUM = 'sum'